import {
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerHeader,
  DrawerTitle,
} from "@/components/ui/drawer";
import type { RowMenuItem } from "./FocusRow";
import { rowReason, type FocusRow } from "./ranking";

// Mobil (kap. 13): et trykk på en rad åpner et handlingsark nederst med
// radens handlinger (også «Åpne kunde»), i stedet for sidepanelet.
export const MobileRowSheet = ({
  row,
  menu,
  onClose,
}: {
  row: FocusRow;
  menu: RowMenuItem[];
  onClose: () => void;
}) => {
  const run = (fn: () => void) => () => {
    onClose();
    // La arket lukke seg før handlingen åpner noe nytt.
    window.setTimeout(fn, 150);
  };
  const items = menu.filter(
    (item): item is Exclude<RowMenuItem, "separator"> => item !== "separator",
  );
  return (
    <Drawer open onOpenChange={(open) => !open && onClose()}>
      <DrawerContent>
        <DrawerHeader className="text-left">
          <DrawerTitle className="text-[15px]">{row.title}</DrawerTitle>
          <DrawerDescription>{rowReason(row)}</DrawerDescription>
        </DrawerHeader>
        <ul className="flex max-h-[60vh] flex-col overflow-y-auto px-2 pb-6">
          {items.map((item) =>
            "items" in item ? (
              <li key={item.label} className="flex flex-col">
                <span className="px-3 pt-3 pb-1 text-xs text-muted-foreground">
                  {item.label}
                </span>
                {item.items.map((sub) => (
                  <button
                    key={sub.label}
                    type="button"
                    onClick={run(sub.onSelect)}
                    className="rounded-md px-3 py-3 text-left text-[15px] active:bg-muted"
                  >
                    {sub.label}
                  </button>
                ))}
              </li>
            ) : (
              <li key={item.label}>
                <button
                  type="button"
                  onClick={run(item.onSelect)}
                  className="w-full rounded-md px-3 py-3 text-left text-[15px] active:bg-muted"
                >
                  {item.label}
                </button>
              </li>
            ),
          )}
        </ul>
      </DrawerContent>
    </Drawer>
  );
};
